// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
/*
export const environment = {
    production: false,
    avatar_url: 'http://api.s-care.eu',
    api_url: 'https://api.sidly-platform.com/api',
    socket_url: 'https://api.sidly-platform.com'
};

*/
export const environment = {
    production: false,
    avatar_url: 'https://api.torun-sidly.pl',
    api_url: 'https://api.torun-sidly.pl/api',
    socket_url: 'https://api.torun-sidly.pl'
};


//api_url: 'http://18.195.117.229/api',
//    socket_url: 'http://18.195.117.229'
//http://127.0.0.1:8000/api



// aws s3 sync dist s3://torun-sidly.pl --profile lukasz.pizon --acl public-read
// aws cloudfront create-invalidation --distribution-id EQMTZZS08RYPW  --paths "/*" --profile lukasz.pizon




// WEBPACK FOOTER //
// ./src/environments/environment.ts